<template>
  <div>
    <my-header></my-header>
    <div class="content-box module-1">
      <div class="content-detail">
        <div class="box">
          <el-carousel :interval="5000" arrow="never" class="detail-img-box" v-if="teamDetail.imgList.length">
            <el-carousel-item v-for="(item, index1) in teamDetail.imgList" :key="index1">
              <img :src="`${item.imgUrl}`"/>
            </el-carousel-item>
          </el-carousel>
          <p class="team-name">{{teamDetail.name}}</p>
          <p class="team-text">{{teamDetail.desc}}</p>
          <!-- <span class="span">”</span> -->
          <img class="span" src="/static/img/detail/yinhao.png">
        </div>
      </div>
    </div>
    <div class="content-box module-2">
      <div class="content-detail">
        <p class="list-title"><i class="line"></i>专业基地介绍</p>
        <p class="detail" v-html="teamDetail.professionalDesc"></p>
        <p class="list-title"><i class="line"></i>教学团队</p>
        <ul class="list">
          <li class="li" v-for="(item, index) in list" :key="index" :class="{'leading-back': item.leading}">
            <img class="img" :src="`${item.imgUrl}`"/>
            <!-- <img v-if="item.leading" class="lead" src="/static/img/detail/1.png"/> -->
            <div class="info">
              <img v-if="item.leading" class="lead-logo" src="/static/img/team/lead.png"/>
              <span class="name">{{item.name}}</span>
              <span v-if="levelArr[item.level]" class="level blue">{{levelArr[item.level].name}}</span>
              <span v-if="otherJobArr[item.otherJob]" class="level green">{{otherJobArr[item.otherJob].name}}</span>
              <span v-if="educationArr[item.education]" class="level yellow">{{educationArr[item.education].name}}</span>
            </div>
            <div class="text" v-html="item.desc"></div>
          </li>
        </ul>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { officialSiteServer } from '@/api/api'
import getImgUrl from '@/mixin/getImgUrl.js'
import myFooter from './myFooter.vue'
import myHeader from './myHeader.vue'
export default {
  name: 'detail',
  components: {
    myHeader: myHeader,
    myFooter: myFooter
  },
  mixins: [getImgUrl],
  data () {
    return {
      teamDetail: {
        img: []
      },
      list: [],
      levelArr: {
        1: { name: '主任医师', cls: '' },
        2: { name: '副主任医师', cls: '' },
        3: { name: '主治医师', cls: '' },
        4: { name: '住院医师', cls: '' }
      },
      educationArr: {
        1: { name: '医学博士后' },
        2: { name: '医学博士' },
        3: { name: '医学硕士' },
        4: { name: '医学本科' }
      },
      otherJobArr: {
        1: { name: '硕士研究生导师' },
        2: { name: '硕士博士生导师' }
      }
    }
  },
  beforeDestroy () {
  },
  mounted () {
    if (localStorage.getItem('hospital')) {
      let hospital = JSON.parse(localStorage.getItem('hospital'))
      if (hospital.teamId) {
        this.readDetail(hospital.teamId)
        this.readMember(hospital.teamId)
      }
    }
  },
  methods: {
    readDetail (teamId) {
      officialSiteServer.getTeamDetail({
        teamId: teamId
      }).then((res) => {
        let { code, data } = res
        if (code === '0') {
          this.teamDetail = data
          this.teamDetail.img = this.teamDetail.img ? this.teamDetail.img.split(',') : []
          this.teamDetail.imgList = []
          this.teamDetail.img.forEach(e => {
            this.teamDetail.imgList.push({
              img: e
            })
          })
          this.getImgUrl(this.teamDetail.imgList, 'img')
        }
      })
    },
    readMember (teamId) {
      officialSiteServer.getTeamMemberList({
        teamId: teamId
      }).then((res) => {
        let { code, data } = res
        if (code === '0') {
          this.list = data
          this.getImgUrl(this.list, 'img')
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@import "~less-lib";
.list-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 38px;
  color: #000000;
  line-height: 56px;
  text-align: left;
  display: flex;
  align-items: center;
  .line{
    display: inline-block;
    width: 4px;
    height: 39px;
    background: #0056F8;
    margin-right: 20px;
  }
}
.module-1 {
  background: #F6F6FA;
  padding: 80px 0;
  .content-detail {
    text-align: right;
  }
  .box {
    background: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
    border-radius: 14px;
    width: 947px;
    min-height: 466px;
    text-align: left;
    position: relative;
    display: inline-block;
    padding: 46px 30px 64px 265px;
  }
  .detail-img-box {
    position: absolute;
    width: 488px;
    height: 366px;
    top: 50px;
    left: -244px;
    border-radius: 10px;
    img {
      width: 488px;
      height: 366px;
    }
  }
  .team-name {
    font-family: SourceHanSansSC-Medium;
    font-size: 38px;
    color: #000000;
    text-align: left;
    font-weight: 500;
    margin-bottom: 30px;
  }
  .team-text {
    font-family: SourceHanSansSC-Regular;
    font-size: 14px;
    color: #666666;
    text-align: justify;
    line-height: 30px;
    font-weight: 400;
    white-space: pre-wrap;
  }
  .span {
    position: absolute;
    right: 30px;
    bottom: 30px;
  }
}
.module-2 {
  background: #F9F9FA;
  padding: 100px 0 120px;
  .detail {
    font-family: SourceHanSansSC-Regular;
    font-size: 14px;
    color: #666666;
    text-align: justify;
    line-height: 30px;
    margin: 31px 0 100px;
    white-space: pre-wrap;
  }
}
.list {
  .li {
    margin-top: 140px;
    position: relative;
    min-height: 374px;
    padding: 29px 50px 0 388px;
    background: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
    border-radius: 14px;
  }
  .leading-back{
    background: url("/static/img/team/lead-back.png") no-repeat;
    background-size: 100% 100%;
  }
  .img {
    width: 288px;
    height: 384px;
    border-radius: 10px;
    position: absolute;
    left: 50px;
    top: -60px;
    overflow: hidden;
    img {
      width: 288px;
      height: 384px;
    }
  }
  .lead {
    position: absolute;
    left: 68px;
    top: -60px;
  }
  .info {
    margin-bottom: 30px;
    text-align: left;
    .lead-logo{
      width: 65px;
      height: 80px;
      vertical-align: middle;
      margin-right: 20px;
    }
  }
  .name {
    font-family: SourceHanSansSC-Medium;
    font-size: 24px;
    color: #000000;
    display: inline-block;
    margin-right: 24px;
  }
  .level {
    border-radius: 4px;
    font-family: SourceHanSansSC-Regular;
    font-size: 14px;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    margin-right: 16px;
  }
  .blue {
    color: #0C59EF;
    background: #EAF7FF;
  }
  .green {
    color: #238E97;
    background: #E8FBFA;
  }
  .yellow {
    color: #E7871E;
    background: #FFF6EC;
  }
  .text {
    font-family: SourceHanSansSC-Regular;
    font-size: 14px;
    color: #666666;
    text-align: justify;
    line-height: 22px;
    white-space: pre-wrap;
  }
}
</style>
<style lang="less">
.detail-img-box {
  .el-carousel__container {
    height: 366px;
  }
  .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #BDBDBD;
    border-radius: 8px;
    opacity: 1;
  }
  .is-active {
    .el-carousel__button {
      width: 20px;
      background: #0056F8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue